interface FooterSwitcherProps {
    footer: React.ReactNode;
}

export const FooterSwitcher: React.FunctionComponent<FooterSwitcherProps> = ({footer}) => {
    return <>{footer}</>;
}